class CustomHeader extends HTMLElement {
    connectedCallback() {
        if (this.dataset.liveHeader === 'true') {
            document.documentElement.classList.add('header-v2-active');
        }

        this.section = this.closest('.custom-header-section');
        this.stickyMode = this.getAttribute('sticky') || 'never';
        this.lastScrollTop = window.scrollY || 0;
        this.navItems = this.querySelectorAll('.custom-header__nav-item');

        this.updateHeaderHeight();

        this.resizeObserver = new ResizeObserver(() => {
            this.updateHeaderHeight();
        });

        this.resizeObserver.observe(this);

        if (this.stickyMode !== 'never') {
            this.section?.classList.add('custom-header-section--sticky');
            window.addEventListener('scroll', this.onScroll, { passive: true });
        }

        this.megaCloseTimer = null;

        this.navItems.forEach((item) => {
            const mega = item.querySelector('.custom-header-mega');

            if (!mega) return;

            item.addEventListener('mouseenter', () => this.openMega(item));
            item.addEventListener('mouseleave', () => this.scheduleCloseMega(item));

            item.addEventListener('focusin', () => this.openMega(item));
            item.addEventListener('focusout', () => this.scheduleCloseMega(item));

            mega.addEventListener('mouseenter', () => this.openMega(item));
            mega.addEventListener('mouseleave', () => this.scheduleCloseMega(item));
        });

        this.headerGroup = document.querySelector('#header-group');

        if (this.stickyMode !== 'never') {
            this.headerGroup?.classList.add('custom-header-group--sticky');
            window.addEventListener('scroll', this.onScroll, { passive: true });
        }

        this.mobileToggle = this.querySelector('[data-mobile-menu-toggle]');
        this.mobileTabs = this.querySelectorAll('[data-mobile-tab-button]');

        this.mobileToggle?.addEventListener('click', this.toggleMobileMenu);

        this.mobileTabs.forEach((button) => {
            button.addEventListener('click', this.onMobileTabClick);
        });
    }

    openMega = (item) => {
        window.clearTimeout(this.megaCloseTimer);

        this.navItems.forEach((navItem) => {
            if (navItem !== item) {
                navItem.classList.remove('is-mega-open');
            }
        });

        item.classList.add('is-mega-open');
        document.body.classList.add('custom-header-mega-open');
    };

    scheduleCloseMega = (item) => {
        window.clearTimeout(this.megaCloseTimer);

        this.megaCloseTimer = window.setTimeout(() => {
            const isStillHoveringItem = item.matches(':hover');
            const isStillHoveringMega = item.querySelector('.custom-header-mega:hover');

            if (isStillHoveringItem || isStillHoveringMega) return;

            item.classList.remove('is-mega-open');

            if (!this.querySelector('.custom-header__nav-item.is-mega-open')) {
                document.body.classList.remove('custom-header-mega-open');
            }
        }, 250);
    };

    toggleMobileMenu = () => {
        const isOpen = this.classList.toggle('is-mobile-menu-open');
        document.body.classList.toggle('custom-header-mobile-open', isOpen);

        // Mobile tabs set custom-header-mega-open too; clear it on close or the body
        // stays scroll-locked and third-party widgets stay hidden after the drawer shuts.
        if (!isOpen) {
            this.querySelectorAll('.custom-header-mobile-tab.is-open').forEach((tab) => {
                tab.classList.remove('is-open');
            });
            document.body.classList.remove('custom-header-mega-open');
        }
    };

    onMobileTabClick = (event) => {
        const currentTab = event.currentTarget.closest('.custom-header-mobile-tab');
        const isOpen = currentTab.classList.contains('is-open');

        this.querySelectorAll('.custom-header-mobile-tab').forEach((tab) => {
            tab.classList.remove('is-open');
            document.body.classList.remove('custom-header-mega-open');
        });

        if (!isOpen) {
            currentTab.classList.add('is-open');
            document.body.classList.add('custom-header-mega-open');
        }
    };

    disconnectedCallback() {
        this.resizeObserver?.disconnect();
        window.removeEventListener('scroll', this.onScroll);
        document.body.classList.remove('custom-header-mega-open');
        document.body.style.removeProperty('--header-height');
        this.headerGroup?.classList.remove('custom-header-group--sticky');
        this.headerGroup?.classList.remove('custom-header-group--hidden');

        this.mobileToggle?.removeEventListener('click', this.toggleMobileMenu);

        this.mobileTabs?.forEach((button) => {
            button.removeEventListener('click', this.onMobileTabClick);
        });

        document.body.classList.remove('custom-header-mobile-open');

        window.clearTimeout(this.megaCloseTimer);

        this.navItems?.forEach((item) => {
            item.classList.remove('is-mega-open');
        });
    }

    updateHeaderHeight = () => {
        document.body.style.setProperty('--header-height', `${this.offsetHeight}px`);
    };

    onScroll = () => {
        if (this.stickyMode !== 'scroll-up') return;

        const currentScrollTop = window.scrollY || 0;
        const isScrollingDown = currentScrollTop > this.lastScrollTop;

        if (currentScrollTop <= this.offsetHeight) {
            this.headerGroup?.classList.remove('custom-header-group--hidden');
        } else if (isScrollingDown) {
            this.headerGroup?.classList.add('custom-header-group--hidden');
        } else {
            this.headerGroup?.classList.remove('custom-header-group--hidden');
        }

        this.lastScrollTop = currentScrollTop;
    };

    lockScroll = () => {
        document.body.classList.add('custom-header-mega-open');
    };

    unlockScroll = () => {
        window.setTimeout(() => {
            if (!this.querySelector('.custom-header__nav-item:hover')) {
                document.body.classList.remove('custom-header-mega-open');
            }
        }, 50);
    };
}

if (!customElements.get('custom-header')) {
    customElements.define('custom-header', CustomHeader);
}